import { useRealTimeOpenAI } from '@vh/components/VHPlayer/RealtimeOpenAIPlayer/useRealTimeOpenAI';
import { createContext } from 'react';

export const RealtimeOpenAIContext = createContext(
  /** @type {ReturnType<useRealTimeOpenAI>} */ ({
    startSession: async () => {},
    sendText: () => {},
    stopSession: () => {},
    connected: false,
    connecting: false,
    error: null,
    setupEvents: () => {},
    audioStream: null,
  })
);

export const RealtimeOpenAIProvider = ({ vhId, shareToken, children }) => {
  const {
    startSession,
    stopSession,
    setupEvents,
    sendText,
    connected,
    connecting,
    error,
    audioStream,
  } = useRealTimeOpenAI({
    vhId,
    shareToken,
  });

  return (
    <RealtimeOpenAIContext.Provider
      value={{
        startSession,
        stopSession,
        setupEvents,
        sendText,
        connected,
        connecting,
        error,
        audioStream,
      }}
    >
      {children}
    </RealtimeOpenAIContext.Provider>
  );
};

export default RealtimeOpenAIProvider;
